/**
 * ITU-T E.164 calling codes for phone country code Select.
 * value = digits only (no +); label = dial code for collapsed display.
 */
const PHONE_COUNTRY_CODES_RAW = [
  { value: "852", label: "+852", country: "Hong Kong", countryZh: "香港", iso: "HK" },
  { value: "86", label: "+86", country: "China", countryZh: "中國", iso: "CN" },
  { value: "853", label: "+853", country: "Macau", countryZh: "澳門", iso: "MO" },
  { value: "886", label: "+886", country: "Taiwan", countryZh: "台灣", iso: "TW" },
  { value: "93", label: "+93", country: "Afghanistan", countryZh: "阿富汗", iso: "AF" },
  { value: "355", label: "+355", country: "Albania", countryZh: "阿爾巴尼亞", iso: "AL" },
  { value: "213", label: "+213", country: "Algeria", countryZh: "阿爾及利亞", iso: "DZ" },
  { value: "376", label: "+376", country: "Andorra", countryZh: "安道爾", iso: "AD" },
  { value: "244", label: "+244", country: "Angola", countryZh: "安哥拉", iso: "AO" },
  { value: "1268", label: "+1268", country: "Antigua and Barbuda", countryZh: "安提瓜和巴布達", iso: "AG" },
  { value: "54", label: "+54", country: "Argentina", countryZh: "阿根廷", iso: "AR" },
  { value: "374", label: "+374", country: "Armenia", countryZh: "亞美尼亞", iso: "AM" },
  { value: "61", label: "+61", country: "Australia", countryZh: "澳大利亞", iso: "AU" },
  { value: "43", label: "+43", country: "Austria", countryZh: "奧地利", iso: "AT" },
  { value: "994", label: "+994", country: "Azerbaijan", countryZh: "亞塞拜然", iso: "AZ" },
  { value: "1242", label: "+1242", country: "Bahamas", countryZh: "巴哈馬", iso: "BS" },
  { value: "973", label: "+973", country: "Bahrain", countryZh: "巴林", iso: "BH" },
  { value: "880", label: "+880", country: "Bangladesh", countryZh: "孟加拉", iso: "BD" },
  { value: "1246", label: "+1246", country: "Barbados", countryZh: "巴巴多斯", iso: "BB" },
  { value: "375", label: "+375", country: "Belarus", countryZh: "白俄羅斯", iso: "BY" },
  { value: "32", label: "+32", country: "Belgium", countryZh: "比利時", iso: "BE" },
  { value: "501", label: "+501", country: "Belize", countryZh: "伯利茲", iso: "BZ" },
  { value: "229", label: "+229", country: "Benin", countryZh: "貝南", iso: "BJ" },
  { value: "975", label: "+975", country: "Bhutan", countryZh: "不丹", iso: "BT" },
  { value: "591", label: "+591", country: "Bolivia", countryZh: "玻利維亞", iso: "BO" },
  { value: "387", label: "+387", country: "Bosnia and Herzegovina", countryZh: "波士尼亞", iso: "BA" },
  { value: "267", label: "+267", country: "Botswana", countryZh: "博茨瓦納", iso: "BW" },
  { value: "55", label: "+55", country: "Brazil", countryZh: "巴西", iso: "BR" },
  { value: "673", label: "+673", country: "Brunei", countryZh: "文萊", iso: "BN" },
  { value: "359", label: "+359", country: "Bulgaria", countryZh: "保加利亞", iso: "BG" },
  { value: "226", label: "+226", country: "Burkina Faso", countryZh: "布吉納法索", iso: "BF" },
  { value: "257", label: "+257", country: "Burundi", countryZh: "布隆迪", iso: "BI" },
  { value: "855", label: "+855", country: "Cambodia", countryZh: "柬埔寨", iso: "KH" },
  { value: "237", label: "+237", country: "Cameroon", countryZh: "喀麥隆", iso: "CM" },
  { value: "1", label: "+1", country: "United States / Canada", countryZh: "美國/加拿大", iso: "US" },
  { value: "238", label: "+238", country: "Cape Verde", countryZh: "維德角", iso: "CV" },
  { value: "236", label: "+236", country: "Central African Republic", countryZh: "中非共和國", iso: "CF" },
  { value: "235", label: "+235", country: "Chad", countryZh: "乍得", iso: "TD" },
  { value: "56", label: "+56", country: "Chile", countryZh: "智利", iso: "CL" },
  { value: "57", label: "+57", country: "Colombia", countryZh: "哥倫比亞", iso: "CO" },
  { value: "269", label: "+269", country: "Comoros", countryZh: "科摩羅", iso: "KM" },
  { value: "242", label: "+242", country: "Congo", countryZh: "剛果", iso: "CG" },
  { value: "243", label: "+243", country: "DR Congo", countryZh: "剛果民主共和國", iso: "CD" },
  { value: "506", label: "+506", country: "Costa Rica", countryZh: "哥斯達黎加", iso: "CR" },
  { value: "385", label: "+385", country: "Croatia", countryZh: "克羅地亞", iso: "HR" },
  { value: "53", label: "+53", country: "Cuba", countryZh: "古巴", iso: "CU" },
  { value: "357", label: "+357", country: "Cyprus", countryZh: "塞浦路斯", iso: "CY" },
  { value: "420", label: "+420", country: "Czech Republic", countryZh: "捷克", iso: "CZ" },
  { value: "45", label: "+45", country: "Denmark", countryZh: "丹麥", iso: "DK" },
  { value: "253", label: "+253", country: "Djibouti", countryZh: "吉布提", iso: "DJ" },
  { value: "1767", label: "+1767", country: "Dominica", countryZh: "多米尼克", iso: "DM" },
  { value: "1809", label: "+1809", country: "Dominican Republic", countryZh: "多米尼加", iso: "DO" },
  { value: "593", label: "+593", country: "Ecuador", countryZh: "厄瓜多爾", iso: "EC" },
  { value: "20", label: "+20", country: "Egypt", countryZh: "埃及", iso: "EG" },
  { value: "503", label: "+503", country: "El Salvador", countryZh: "薩爾瓦多", iso: "SV" },
  { value: "240", label: "+240", country: "Equatorial Guinea", countryZh: "赤道幾內亞", iso: "GQ" },
  { value: "291", label: "+291", country: "Eritrea", countryZh: "厄立特里亞", iso: "ER" },
  { value: "372", label: "+372", country: "Estonia", countryZh: "愛沙尼亞", iso: "EE" },
  { value: "251", label: "+251", country: "Ethiopia", countryZh: "埃塞俄比亞", iso: "ET" },
  { value: "679", label: "+679", country: "Fiji", countryZh: "斐濟", iso: "FJ" },
  { value: "358", label: "+358", country: "Finland", countryZh: "芬蘭", iso: "FI" },
  { value: "33", label: "+33", country: "France", countryZh: "法國", iso: "FR" },
  { value: "594", label: "+594", country: "French Guiana", countryZh: "法屬圭亞那", iso: "GF" },
  { value: "689", label: "+689", country: "French Polynesia", countryZh: "法屬波利尼西亞", iso: "PF" },
  { value: "241", label: "+241", country: "Gabon", countryZh: "加蓬", iso: "GA" },
  { value: "220", label: "+220", country: "Gambia", countryZh: "岡比亞", iso: "GM" },
  { value: "995", label: "+995", country: "Georgia", countryZh: "格魯吉亞", iso: "GE" },
  { value: "49", label: "+49", country: "Germany", countryZh: "德國", iso: "DE" },
  { value: "233", label: "+233", country: "Ghana", countryZh: "加納", iso: "GH" },
  { value: "30", label: "+30", country: "Greece", countryZh: "希臘", iso: "GR" },
  { value: "1473", label: "+1473", country: "Grenada", countryZh: "格林納達", iso: "GD" },
  { value: "502", label: "+502", country: "Guatemala", countryZh: "危地馬拉", iso: "GT" },
  { value: "224", label: "+224", country: "Guinea", countryZh: "幾內亞", iso: "GN" },
  { value: "245", label: "+245", country: "Guinea-Bissau", countryZh: "幾內亞比紹", iso: "GW" },
  { value: "592", label: "+592", country: "Guyana", countryZh: "圭亞那", iso: "GY" },
  { value: "509", label: "+509", country: "Haiti", countryZh: "海地", iso: "HT" },
  { value: "504", label: "+504", country: "Honduras", countryZh: "洪都拉斯", iso: "HN" },
  { value: "36", label: "+36", country: "Hungary", countryZh: "匈牙利", iso: "HU" },
  { value: "354", label: "+354", country: "Iceland", countryZh: "冰島", iso: "IS" },
  { value: "91", label: "+91", country: "India", countryZh: "印度", iso: "IN" },
  { value: "62", label: "+62", country: "Indonesia", countryZh: "印尼", iso: "ID" },
  { value: "98", label: "+98", country: "Iran", countryZh: "伊朗", iso: "IR" },
  { value: "964", label: "+964", country: "Iraq", countryZh: "伊拉克", iso: "IQ" },
  { value: "353", label: "+353", country: "Ireland", countryZh: "愛爾蘭", iso: "IE" },
  { value: "972", label: "+972", country: "Israel", countryZh: "以色列", iso: "IL" },
  { value: "39", label: "+39", country: "Italy", countryZh: "意大利", iso: "IT" },
  { value: "225", label: "+225", country: "Ivory Coast", countryZh: "象牙海岸", iso: "CI" },
  { value: "1876", label: "+1876", country: "Jamaica", countryZh: "牙買加", iso: "JM" },
  { value: "81", label: "+81", country: "Japan", countryZh: "日本", iso: "JP" },
  { value: "962", label: "+962", country: "Jordan", countryZh: "約旦", iso: "JO" },
  { value: "7", label: "+7", country: "Russia / Kazakhstan", countryZh: "俄羅斯/哈薩克", iso: "RU" },
  { value: "254", label: "+254", country: "Kenya", countryZh: "肯尼亞", iso: "KE" },
  { value: "686", label: "+686", country: "Kiribati", countryZh: "基里巴斯", iso: "KI" },
  { value: "850", label: "+850", country: "North Korea", countryZh: "北韓", iso: "KP" },
  { value: "82", label: "+82", country: "South Korea", countryZh: "韓國", iso: "KR" },
  { value: "965", label: "+965", country: "Kuwait", countryZh: "科威特", iso: "KW" },
  { value: "996", label: "+996", country: "Kyrgyzstan", countryZh: "吉爾吉斯", iso: "KG" },
  { value: "856", label: "+856", country: "Laos", countryZh: "老撾", iso: "LA" },
  { value: "371", label: "+371", country: "Latvia", countryZh: "拉脫維亞", iso: "LV" },
  { value: "961", label: "+961", country: "Lebanon", countryZh: "黎巴嫩", iso: "LB" },
  { value: "266", label: "+266", country: "Lesotho", countryZh: "萊索托", iso: "LS" },
  { value: "231", label: "+231", country: "Liberia", countryZh: "利比里亞", iso: "LR" },
  { value: "218", label: "+218", country: "Libya", countryZh: "利比亞", iso: "LY" },
  { value: "423", label: "+423", country: "Liechtenstein", countryZh: "列支敦士登", iso: "LI" },
  { value: "370", label: "+370", country: "Lithuania", countryZh: "立陶宛", iso: "LT" },
  { value: "352", label: "+352", country: "Luxembourg", countryZh: "盧森堡", iso: "LU" },
  { value: "389", label: "+389", country: "North Macedonia", countryZh: "北馬其頓", iso: "MK" },
  { value: "261", label: "+261", country: "Madagascar", countryZh: "馬達加斯加", iso: "MG" },
  { value: "265", label: "+265", country: "Malawi", countryZh: "馬拉維", iso: "MW" },
  { value: "60", label: "+60", country: "Malaysia", countryZh: "馬來西亞", iso: "MY" },
  { value: "960", label: "+960", country: "Maldives", countryZh: "馬爾代夫", iso: "MV" },
  { value: "223", label: "+223", country: "Mali", countryZh: "馬里", iso: "ML" },
  { value: "356", label: "+356", country: "Malta", countryZh: "馬耳他", iso: "MT" },
  { value: "692", label: "+692", country: "Marshall Islands", countryZh: "馬紹爾群島", iso: "MH" },
  { value: "222", label: "+222", country: "Mauritania", countryZh: "毛里塔尼亞", iso: "MR" },
  { value: "230", label: "+230", country: "Mauritius", countryZh: "毛里求斯", iso: "MU" },
  { value: "52", label: "+52", country: "Mexico", countryZh: "墨西哥", iso: "MX" },
  { value: "691", label: "+691", country: "Micronesia", countryZh: "密克羅尼西亞", iso: "FM" },
  { value: "373", label: "+373", country: "Moldova", countryZh: "摩爾多瓦", iso: "MD" },
  { value: "377", label: "+377", country: "Monaco", countryZh: "摩納哥", iso: "MC" },
  { value: "976", label: "+976", country: "Mongolia", countryZh: "蒙古", iso: "MN" },
  { value: "382", label: "+382", country: "Montenegro", countryZh: "黑山", iso: "ME" },
  { value: "212", label: "+212", country: "Morocco", countryZh: "摩洛哥", iso: "MA" },
  { value: "258", label: "+258", country: "Mozambique", countryZh: "莫桑比克", iso: "MZ" },
  { value: "95", label: "+95", country: "Myanmar", countryZh: "緬甸", iso: "MM" },
  { value: "264", label: "+264", country: "Namibia", countryZh: "納米比亞", iso: "NA" },
  { value: "674", label: "+674", country: "Nauru", countryZh: "瑙魯", iso: "NR" },
  { value: "977", label: "+977", country: "Nepal", countryZh: "尼泊爾", iso: "NP" },
  { value: "31", label: "+31", country: "Netherlands", countryZh: "荷蘭", iso: "NL" },
  { value: "64", label: "+64", country: "New Zealand", countryZh: "新西蘭", iso: "NZ" },
  { value: "505", label: "+505", country: "Nicaragua", countryZh: "尼加拉瓜", iso: "NI" },
  { value: "227", label: "+227", country: "Niger", countryZh: "尼日爾", iso: "NE" },
  { value: "234", label: "+234", country: "Nigeria", countryZh: "尼日利亞", iso: "NG" },
  { value: "47", label: "+47", country: "Norway", countryZh: "挪威", iso: "NO" },
  { value: "968", label: "+968", country: "Oman", countryZh: "阿曼", iso: "OM" },
  { value: "92", label: "+92", country: "Pakistan", countryZh: "巴基斯坦", iso: "PK" },
  { value: "680", label: "+680", country: "Palau", countryZh: "帕勞", iso: "PW" },
  { value: "970", label: "+970", country: "Palestine", countryZh: "巴勒斯坦", iso: "PS" },
  { value: "507", label: "+507", country: "Panama", countryZh: "巴拿馬", iso: "PA" },
  { value: "675", label: "+675", country: "Papua New Guinea", countryZh: "巴布亞新幾內亞", iso: "PG" },
  { value: "595", label: "+595", country: "Paraguay", countryZh: "巴拉圭", iso: "PY" },
  { value: "51", label: "+51", country: "Peru", countryZh: "秘魯", iso: "PE" },
  { value: "63", label: "+63", country: "Philippines", countryZh: "菲律賓", iso: "PH" },
  { value: "48", label: "+48", country: "Poland", countryZh: "波蘭", iso: "PL" },
  { value: "351", label: "+351", country: "Portugal", countryZh: "葡萄牙", iso: "PT" },
  { value: "1787", label: "+1787", country: "Puerto Rico", countryZh: "波多黎各", iso: "PR" },
  { value: "974", label: "+974", country: "Qatar", countryZh: "卡塔爾", iso: "QA" },
  { value: "40", label: "+40", country: "Romania", countryZh: "羅馬尼亞", iso: "RO" },
  { value: "250", label: "+250", country: "Rwanda", countryZh: "盧旺達", iso: "RW" },
  { value: "966", label: "+966", country: "Saudi Arabia", countryZh: "沙特阿拉伯", iso: "SA" },
  { value: "221", label: "+221", country: "Senegal", countryZh: "塞內加爾", iso: "SN" },
  { value: "381", label: "+381", country: "Serbia", countryZh: "塞爾維亞", iso: "RS" },
  { value: "248", label: "+248", country: "Seychelles", countryZh: "塞舌爾", iso: "SC" },
  { value: "232", label: "+232", country: "Sierra Leone", countryZh: "塞拉利昂", iso: "SL" },
  { value: "65", label: "+65", country: "Singapore", countryZh: "新加坡", iso: "SG" },
  { value: "421", label: "+421", country: "Slovakia", countryZh: "斯洛伐克", iso: "SK" },
  { value: "386", label: "+386", country: "Slovenia", countryZh: "斯洛文尼亞", iso: "SI" },
  { value: "677", label: "+677", country: "Solomon Islands", countryZh: "所羅門群島", iso: "SB" },
  { value: "252", label: "+252", country: "Somalia", countryZh: "索馬里", iso: "SO" },
  { value: "27", label: "+27", country: "South Africa", countryZh: "南非", iso: "ZA" },
  { value: "211", label: "+211", country: "South Sudan", countryZh: "南蘇丹", iso: "SS" },
  { value: "34", label: "+34", country: "Spain", countryZh: "西班牙", iso: "ES" },
  { value: "94", label: "+94", country: "Sri Lanka", countryZh: "斯里蘭卡", iso: "LK" },
  { value: "249", label: "+249", country: "Sudan", countryZh: "蘇丹", iso: "SD" },
  { value: "597", label: "+597", country: "Suriname", countryZh: "蘇里南", iso: "SR" },
  { value: "268", label: "+268", country: "Eswatini", countryZh: "斯威士蘭", iso: "SZ" },
  { value: "46", label: "+46", country: "Sweden", countryZh: "瑞典", iso: "SE" },
  { value: "41", label: "+41", country: "Switzerland", countryZh: "瑞士", iso: "CH" },
  { value: "963", label: "+963", country: "Syria", countryZh: "敘利亞", iso: "SY" },
  { value: "992", label: "+992", country: "Tajikistan", countryZh: "塔吉克", iso: "TJ" },
  { value: "255", label: "+255", country: "Tanzania", countryZh: "坦桑尼亞", iso: "TZ" },
  { value: "66", label: "+66", country: "Thailand", countryZh: "泰國", iso: "TH" },
  { value: "670", label: "+670", country: "Timor-Leste", countryZh: "東帝汶", iso: "TL" },
  { value: "228", label: "+228", country: "Togo", countryZh: "多哥", iso: "TG" },
  { value: "676", label: "+676", country: "Tonga", countryZh: "湯加", iso: "TO" },
  { value: "1868", label: "+1868", country: "Trinidad and Tobago", countryZh: "特立尼達", iso: "TT" },
  { value: "216", label: "+216", country: "Tunisia", countryZh: "突尼斯", iso: "TN" },
  { value: "90", label: "+90", country: "Turkey", countryZh: "土耳其", iso: "TR" },
  { value: "993", label: "+993", country: "Turkmenistan", countryZh: "土庫曼", iso: "TM" },
  { value: "688", label: "+688", country: "Tuvalu", countryZh: "圖瓦盧", iso: "TV" },
  { value: "256", label: "+256", country: "Uganda", countryZh: "烏干達", iso: "UG" },
  { value: "380", label: "+380", country: "Ukraine", countryZh: "烏克蘭", iso: "UA" },
  { value: "971", label: "+971", country: "United Arab Emirates", countryZh: "阿聯酋", iso: "AE" },
  { value: "44", label: "+44", country: "United Kingdom", countryZh: "英國", iso: "GB" },
  { value: "598", label: "+598", country: "Uruguay", countryZh: "烏拉圭", iso: "UY" },
  { value: "998", label: "+998", country: "Uzbekistan", countryZh: "烏茲別克", iso: "UZ" },
  { value: "678", label: "+678", country: "Vanuatu", countryZh: "瓦努阿圖", iso: "VU" },
  { value: "58", label: "+58", country: "Venezuela", countryZh: "委內瑞拉", iso: "VE" },
  { value: "84", label: "+84", country: "Vietnam", countryZh: "越南", iso: "VN" },
  { value: "967", label: "+967", country: "Yemen", countryZh: "也門", iso: "YE" },
  { value: "260", label: "+260", country: "Zambia", countryZh: "贊比亞", iso: "ZM" },
  { value: "263", label: "+263", country: "Zimbabwe", countryZh: "津巴布韋", iso: "ZW" },
];

const PRIORITY_CODES = new Set(["852", "86", "853", "886"]);

export const isoToFlagEmoji = (iso) => {
  if (!iso || typeof iso !== "string" || iso.length !== 2) return "";
  return iso
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));
};

export const DATA_PHONE_COUNTRY_CODES = [
  ...PHONE_COUNTRY_CODES_RAW.filter((item) => PRIORITY_CODES.has(item.value)),
  ...PHONE_COUNTRY_CODES_RAW.filter((item) => !PRIORITY_CODES.has(item.value)),
];

export const filterPhoneCountryCode = (value, item) => {
  const query = String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/^\+/, "");
  if (!query) return true;

  const haystack = [
    item.label,
    item.value,
    item.country,
    item.countryZh,
  ]
    .map((part) => String(part ?? "").toLowerCase())
    .join(" ");

  return haystack.includes(query) || String(item.value ?? "").includes(query);
};
